/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {GenericObject} from '@ion/core/src/types/entities';
import {safeJSONParse} from '@ion/core/src/utils/JSONUtils';
import {ACTIONS} from '@ion/dls/src/editors/features/helpers';

/**
 * Provides a utility hook to check the current user role has list
 * of CARB feature enabled.
 *
 * ```typescript
 *
 * import {useCarbServiceFeatures} from '@ion/applications/src/hooks/';
 *
 * const carbServiceFeatures = useCarbServiceFeatures();
 *
 * ```
 *
 */
export const useCarbServiceFeatures = (Features: GenericObject) => {
  const access = {
    hasRead   : false,
    hasUpdate : false
  };
  
  try {
    const extendedAttribute = Features.getExtendedAttribute();
    const userFeatures      = safeJSONParse(extendedAttribute);
    const servicesFeatures  = userFeatures?.features?.find((item) => Features?.isServiceEnablementFeature(item?.id));
    const carbFeatures      = servicesFeatures?.features?.find(item => Features?.isCarbFeature(item?.id));

    if (carbFeatures) {
      const moduleMap = carbFeatures?.modules?.reduce((acc, m) => ({...acc, [m.name]: m?.enabled}), {});

      access.hasRead   = moduleMap?.[ACTIONS.READ] || false;
      access.hasUpdate = moduleMap?.[ACTIONS.UPDATE] || false;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error in useCarbServiceFeatures:', error);
  }

  return access;
};

export default useCarbServiceFeatures;
